import { Component, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseListCtl, ServiceLocatorService } from '@ncs/ncs-lib';

@Component({
  selector: 'app-application-dashboard',
  templateUrl: './application-dashboard.component.html',
  styleUrls: ['./application-dashboard.component.css']
})
export class ApplicationDashboardComponent extends BaseListCtl implements OnDestroy {
 public selectApp: any = undefined;

  public editor: string = '';

    public accessList: string[] = [];

  imagePreview: string | ArrayBuffer | null = null;

  userAppUrl: string = '';

  public maxFileSize = 512000;

  public errorMessage: string | null = null;

  public isArchiveActive: boolean = false;

  public applicationRoles: any = [];
  public currentRoleData: any;
  constructor(
    public override locator: ServiceLocatorService,
    public override route: ActivatedRoute
  ) {
    super('', locator, route);
    locator.config
      .getProperty('endpoint.application')
      .then((property: string) => {
        this.initApiEndpoint(property);
      });
    let _self = this;
    //this.form.preload["applist"] = [];
    locator.getPathVariable(route, function (params: any) {
      _self.form.searchParams['appId'] = params['appId'];
      _self.searchArchived();
    });

    locator.config
      .getProperty('USER_APP_SERVER_URL')
      .then((property: string) => {
        _self.userAppUrl = property;
      });
    this.loadAccessFromLocalStorage();
    this.CurrentRoleData();
  }
  loadAccessFromLocalStorage() {
    let keySuffix = this.locator.config.get('CONTEXT_PATH') + '-';
    const stored = localStorage.getItem(keySuffix + 'accessList');
    if (!stored) {
      this.accessList = [];
      return;
    }

    try {
      this.accessList = JSON.parse(stored) || [];
    } catch (e) {
      console.error('Invalid accessList in localStorage');
      this.accessList = [];
    }
  }

  hasAccess(permission: string): boolean {
    if (!this.accessList || this.accessList.length === 0) {
      return true;
    }
      return this.accessList.includes(permission);
 }

  hasPermissionData(permission: string) {
    const defaultPermission = {
      create: 0,
      read: 0,
      update: 0,
      delete: 0,
    };

    return (
       this.currentRoleData?.accessPermissions?.[permission] ||
      defaultPermission
    );
  }

  CurrentRoleData() {
    let keySuffix = this.locator.config.get('CONTEXT_PATH') + '-';
    const applicationRoleId = localStorage.getItem(keySuffix + 'roleId');

    if (!applicationRoleId) {
      console.log('No roleId found in localStorage');
    }

    const url =
      this.locator.config.get('endpoint.application.role') +
      '/get/' +
      applicationRoleId;

    this.locator.http.get(url, (res: any, error: boolean) => {
      if (error) {
        console.error('Server Error:', error);
      }

      let data = res.result?.data || null;
      this.currentRoleData = data;
    });
  }

  ngOnDestroy() {
    //this.scriptLoader.cleanupJQueryFunctions();
  }

  override populateForm(form: any, data: any) {
    form.id = data.id;
    form.name = data.name;
    form.appUrl = data.appUrl;
    form.userName = data.userName;
    form.userId = data.userId;
    form.orgName = data.orgName;
    form.status = data.status;
    form.logo = data.logo;
    form.code = data.code;
    form.enableUserSignup = data.enableUserSignup;
    form.roleId = data.roleId;
    form.domainUrl = data.domainUrl;

    // These fields are required for checkbox to reflect correctly:
    form.loginByEmail = data.loginByEmail;
    form.loginByMobileNo = data.loginByMobileNo;
    form.loginByLoginCode = data.loginByLoginCode;
  }

  override ngOnInit() {
    this.locator.config
      .getProperty('USER_APP_SERVER_URL')
      .then((property: string) => {
        this.preload();
        this.search();
        //this.display();
      });
  }

  /**
   * Display the list of applications
   */
  display() {
    let _self = this;
    let url = this.locator.getEndpoint('endpoint.user') + '/applications';
    this.locator.http.get(url, function (res: any, error: boolean) {
      if (error) {
        alert('Server Error:' + error);
        return;
      }
      _self.form.error = !res.success;
      _self.form.message = res.message;
    });
  }

  //--------------------------------------Routes declearations----------------------------------------

  /**
   * Go to
   * @param id
   */
  goto(id: number) {
    this.forward('api/' + id);
  }

  /**
   * Go to usecase
   * @param id
   */
  gotousecase(id: number) {
    this.forward('usecase/' + id);
  }

  /**
   * go to urules
   * @param id
   */
  gotourules(id: number) {
    this.forward('rules/' + id);
  }

  /**
   * Go to form
   * @param id
   */
  gotoForm(id: number) {
    this.forward('uiformlist/' + id);
  }
  /**
   * redirect to url
   * @param url , id
   */

  redirect_to(url: string, id: number) {
    this.forward(url + id);
  }

  //--------------------------------------------------------------------------------------

  /**
   * Make URL
   * @returns
   */
  public makeUrl() {
    let _self = this;
    let name = _self.form.data['name'];
    if (_self.locator.dataValidator.isNotNull(name)) {
      // Trim the string
      name = name.trim();

      // Remove special characters using regex
      name = name.replace(/[^\w\s]/gi, '');

      // Replace spaces with hyphens
      name = name.replace(/ /g, '-');

      // Remove white spaces
      name = name.replace(/\s/g, '');

      // Convert to lowercase
      name = name.toLowerCase();

      _self.form.data['appUrl'] = name;
    }
    _self.checkUrl();
    return name;
  }

  /**
   * Check Url is valid
   * @returns
   */
  public checkUrl() {
    let _self = this;
    let url =
      this.locator.getEndpoint('endpoint.application') +
      '/checkurl/' +
      _self.form.data['appUrl'];
    this.locator.http.get(url, function (res: any, error: boolean) {
      if (error) {
        alert('Server Error:' + error);
        return;
      }
      _self.form.error = !res.success;
      _self.form.message = res.message;
      if (_self.form.error) {
        _self.form.data['appUrl'] = res.result.url;
      }
    });
    return '';
  }

  /**
   * Set App
   * @param app
   * @param edit
   */
  setApp(app: any, edit: string) {
    this.selectApp = app;
    this.editor = edit;
  }

  /**
   * Show Preview ofe image
   * @param Event
   */
  showPreview(event: any) {
    const target = event.target as HTMLInputElement;
    const file = target.files ? target.files[0] : null;

    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        this.imagePreview = reader.result; // Set the image preview
      };
      reader.readAsDataURL(file); // Convert the file to base64 URL
    }
  }

  /**
   * Get Thumbnail of the image
   * @param logo
   * @returns
   */
  getDocThumbnailImage(logo: any) {
    return this.getDocThumbnail(logo);
  }

  /**
   * Upload Image
   * @param event
   * @param code
   * @param imageId
   */

selectedFile: File | null = null;
selectedFileCode: any;
selectedImageId: any = 0;

public onFileChanged(event: any, code: string, imageId: any): void {
    const fileObj = event.target.files[0];
  if (!fileObj) return;

  const fileName = fileObj.name.toLowerCase();
  const fileExtension = fileName.substring(fileName.lastIndexOf('.') + 1);
  //Block TIF/TIFF strictly using file extension
  if (fileExtension === 'tif' || fileExtension === 'tiff') {
    this.errorMessage =
      'TIFF files are not supported. Please upload JPG or PNG images.';
    this.imagePreview = null;
    this.selectedFile = null;
    return;
  }  
    if (fileObj.size > this.maxFileSize) {
      this.errorMessage = 'File size should not exceed 0.5 MB.';
    return;
  }
    this.showPreview(event);
      this.errorMessage = null;

  // Store the file and metadata locally
  this.selectedFile = fileObj;
  this.selectedFileCode = code;
  this.selectedImageId = imageId ?? 0;
      }

  resetSearch() {
    var _self = this;
    _self.resetSearchForm();
    _self.search();
  }

  getAppURL(app: any, event: any) {
    event.preventDefault();
    var _self = this;
    const url = _self.userAppUrl + app['orgId'] + '.' + app['id'];
    window.open(url, '_blank', 'noopener,noreferrer');
  }

  copied = false;

  activeIndex!: Number | null;

  copyAppURL(app: any, event: any, activeIndex: any): void {
    event.preventDefault();
    this.activeIndex = activeIndex;
    const url = this.userAppUrl + app['orgId'] + '.' + app['id'];

    // Use Clipboard API to copy the URL
    navigator.clipboard.writeText(url).then(
      () => {
        this.copied = true; // Show the tooltip
        setTimeout(
          () => ((this.copied = false), (this.activeIndex = null)),
          3000
        ); // Hide after 2 seconds
      },
      (err) => {
        console.error('Failed to copy URL: ', err);
      }
    );
  }

  appUrlInvalid = false;
  appname = false;

  validateString(event: Event): void {
    const input = event.target as HTMLInputElement;
    let value = input.value;
    const regex = /^[a-zA-Z0-9]+( [a-zA-Z0-9]+)?$/;
    this.appUrlInvalid = !regex.test(value);
    if (this.appUrlInvalid) {
      this.form.inputerror['appUrl'] = 'Special characters are not allowed!';
      this.form.data['appUrl'] = this.form.data['appUrl'].replace(
        /[^a-zA-Z0-9 ]*/g,
        ''
      );
      this.appUrlInvalid = false;
      this.form.inputerror['appUrl'] = null;
    } else {
      this.form.inputerror['appUrl'] = null;
    }
  }

checkValue(event: Event): void {
  const input = event.target as HTMLInputElement;
  const value = this.normalizeSpaces(input.value.trim());
  console.log('Original Value:', value);

  // Normalize and capitalize the input value
  this.form.data['name'] = value === '' ? null : this.capitalizeWords(value);

  // Check if the name is empty
  if (!this.form.data['name']) {
    this.form.data['name'] = undefined;
    this.form.inputerror['name'] = 'Name is required';
    this.appname = true;
  } else if (this.form.data['name'].length > 40) { 
    // Check if the name exceeds 40 characters
    this.form.inputerror['name'] = 'Application Name is too long.';
    this.appname = false; // Ensure Save button remains enabled
  } else {
    // Valid name input
    this.appname = false;
    this.form.inputerror['name'] = null;
  }
}

  /**
   * Normalize spaces in a string to ensure only one space between words.
   * @param str - Input string to normalize.
   * @returns Normalized string with single spaces.
   */
  normalizeSpaces(str: string): string {
    return str.replace(/\s+/g, ' '); // Replace multiple spaces with a single space
  }

  /**
   * Capitalize the first letter of each word in a string, allowing words with all uppercase characters.
   * @param str - Input string to capitalize.
   * @returns String with the first letter of each word capitalized or unchanged if all characters are uppercase.
   */
  capitalizeWords(str: string): string {
    return str
      .split(' ') // Split the string by spaces
      .map(
        (word) =>
          word === word.toUpperCase() // Check if all characters are uppercase
            ? word // Keep the word as is if all characters are uppercase
            : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase() // Otherwise, capitalize the first letter
      )
      .join(' '); // Join the array back into a string with spaces
  }

  unSetApp() {
    this.editor = '';
  }

  /**
   * toggle of Archived and main list
   * @param tab
   */
  toggleTab(tab: string): void {
    this.isArchiveActive = tab === 'archived';
  }

  /**
   * Archived data search
   * @param callback
   */
  async searchArchived(callback?: any) {
    var _self = this;
    _self.form.searchError = false;
    _self.form.searchMessage = '';

    this.locator.config
      .getProperty('endpoint.application')
      .then((property: string) => {
        let url = property + '/searchArchived/' + _self.form.pageNo;
        _self.form.searchParams['pageSize'] = _self.form.pageSize;

        this.locator.http.post(
          url,
          _self.form.searchParams,
          async function (res: any, error: any) {
            if (error) {
              if (callback) {
                callback(error);
              }

              return;
            }

            _self.form.searchError = !res.success;
            _self.form.searchMessage = res.result['message'];

            if (res.success) {
              _self.form.archivedlist = res.result.data || [];               
            
              _self.form.pageCount = res.result.pageCount;
              _self.form.pageSize = res.result.pageSize;
              _self.form.pageNos = _self.form.pageNo;
              _self.form.pageNoList = [];
              //Build page number list
              for (let i = 0; i < _self.form.pageCount; i++) {
                _self.form.pageNoList.push(i);
              }

              //Check empty list
              if (_self.form.archivedlist.length == 0) {
                _self.form.message = 'No record found';
                _self.form.error = true;
              }

              // Add data in Datatable
              //_self.initializeDataTable();

              if (callback) {
                callback();
              }
            } else {
              _self.form.archivedlist = [];
            }

            if (callback) {
              callback();
            }
          }
        );
      });
  }

  /**
   * Retrieve a record and execute callback after deletion
   *
   * @param id
   * @param callback
   */
  async retrieve(id: any, callback?: any) {
    var _self = this;
    _self.form.error = false;
    _self.form.message = '';
    _self.form.isConfirmDelete = true;
    if (id && id > 0) {
      if (_self.form.isConfirmDelete) {
        let flag = confirm('Are you sure ?');
        if (!flag) {
          return;
        }

      // 🔧 Await the config property
        let baseUrl = await this.locator.config.getProperty(
          'endpoint.application'
        );
      let url = baseUrl + '/retrieve/' + id;

        this.locator.http.get(url, async function (res: any, error: any) {
          if (error) {
            return;
          }
          _self.form.error = !res.success;
          _self.form.message = res.result.message;
          if (res.success) {
            _self.form.message = 'Data is retrieved';
            await _self.searchArchived();

            if (callback) {
              callback(res, error);
            }
            _self.search();
          }
        });
      }
    }
  }

  /**
   * override delete for searchArchived call
   * @param id
   * @param callback
   */
  override async delete(id: number, callback?: any): Promise<void> {
    try {
      await super.delete(id); // Assuming `super.delete` is an async method.
      await this.searchArchived(); // Assuming `this.searchArchived` is also an async method.
      if (callback) callback();
    } catch (error) {
      console.error(
        'Error occurred while deleting and searching archived:',
        error
      );
      if (callback) callback(error);
    }
  }

  override get(id: number, callback?: any): void {
    this.getApplicationRoles(id);
    super.get(id);
    if (callback) callback();
  }
  /**
   * Get usecase attributes
   * @param id
   */
  getApplicationRoles(id: any) {
    let _self = this;
    if (id === 0) {
      return;
    }
    let url =
      this.locator.config.get('endpoint.application.users') +
      '/application-roles/' +
      id;
    this.locator.http.get(url, function (res: any, error: boolean) {
      if (error) {
        alert('Server Error:' + error);
        return;
      }
      _self.applicationRoles = res.result.data;
    });
  }

  ngAfterViewInit() {
    const modalEl = document.getElementById('appRoleModal');
    if (modalEl) {
      modalEl.addEventListener('hidden.bs.modal', () => {
        this.unSetApp(); 
      });
    }
  }
  
truncate(text: string, limit: number): string {
  if (!text) return '';
  return text.length > limit ? text.substring(0, limit) + '...' : text;
}

 saveData() {
     this.errorMessage = '';
  // Validate file size only if file is selected
  if (this.selectedFile && this.selectedFile.size > this.maxFileSize) {
    this.errorMessage = 'File size should not exceed 0.5 MB.';
    return;
  }

  // Upload file if selected
  if (this.selectedFile && this.selectedFileCode) {
    const url =
      this.locator.getEndpoint('endpoint.api.v1') +
      '/cuickdev/application/doc/' +
      this.form.data['id'] +
      '/' +
      this.selectedImageId +
      '/' +
      this.selectedFileCode;

    const param = { id: this.form.data.id };

    this.locator.http.postMutipart(
      url,
      param,
      this.selectedFile,
      (res: any, error: any) => {
        if (error) {
          alert(error);
          return;
        }

        this.form.error = !res.success;
        this.form.message = res.result.message;

        if (res.success) {
          this.form.message = 'File is uploaded';
          this.form.data[this.selectedFileCode] = res.result.data.logo;
          this.changeDoc();
          this.getDoc(this.form.data[this.selectedFileCode]);
          this.search();       

          // Clear stored file
          this.selectedFile = null;
          this.selectedFileCode = null;
          this.selectedImageId = 0;

          // Now call base save
          super.save();
        }
      }
    );
  } else {
    // If no file is selected, just save directly
    super.save();
  }
}

  imagePreviewReset() {
    this.imagePreview = null;
  }
  search1() {
    this.form.list = []; 
    this.search();       
  }
  checkDefaultLogin() {
    if (this.form.data['loginByEmail'] === undefined) {
      this.form.data['loginByEmail'] = true;
    }
}
  override getDocThumbnail(skey: number) {
    if (!skey) {
      skey = 0;
    }
    let docAPI = this.locator.config.get('DOC_API');
    return docAPI + 'th/' + skey + '?t=' + this.imageTimestamp;
  }
}
